import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

var _components$data$dest;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType';
import calendarPie from '@/components/env-bigData/calendarPie';
import calendar from '@/components/env-bigData/calendar';
import monthSelect from '@/components/date/bmonthSelect';
import warn from '@/components/border/warn';
import analysis from '@/components/env-bigData/analysis'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate'; // 设备在线状态统计

import deviceOnlineStatus from '@/components/env-bigData/deviceOnlineStatus';
import dayBarType from '@/components/env-bigData/dayBarType';
import { getAction } from '@/api/manage';
import { queryBigDataById, queryWastDateList, querSkyReport, jxSkyStandardMonth, queryScreenWarn, querySkyCurveAnalysis, querySkyPie, queryStandardTreeList, querySiteList } from '@/api/api';
export default (_components$data$dest = {
  components: {
    dayBarType: dayBarType,
    border: border,
    instrument: instrument,
    barType: barType,
    calendarPie: calendarPie,
    calendar: calendar,
    monthSelect: monthSelect,
    warn: warn,
    analysis: analysis,
    plate: plate,
    doublePlate: doublePlate,
    deviceOnlineStatus: deviceOnlineStatus
  },
  data: function data() {
    return {
      firstPollution: 'PM10',
      radioList: [{
        label: '全部',
        value: 0
      }, {
        label: '数据报警',
        value: 1
      }, {
        label: '设备报警',
        value: 2
      }],
      siteList: [],
      defaultSite: 205,
      realTimeData: [],
      analysisHeight: '',
      calendarHeight: '',
      warnHeight: '',
      siteId: '209',
      showState: true,
      siteDetail: {},
      showToast: false,
      stand: [],
      toastText: '',
      showCalendar: true,
      showDetail: false,
      showIt: false,
      showPie: true,
      quantum: '',
      standardList: [],
      waterWarnList: [],
      defaultValues: 0,
      defaultValue: 1,
      radioIndex: '',
      radioStatu: true,
      showRadio: true,
      showAnalysis: false,
      analysisType: 11,
      title: [],
      colors: ['#ccc'],
      imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
      timer: null,
      timer1: null,
      timer2: null
    };
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resetWidth);
    clearInterval(this.Inter);
  },
  mounted: function mounted() {
    var _this = this;

    //自适应
    this.resetWidth();
    window.addEventListener('resize', this.resetWidth, false);
    this.initData(this.siteId);
    this.timer = setInterval(function () {
      _this.initData(_this.siteId);
    }, 180000);
  }
}, _defineProperty(_components$data$dest, "destroyed", function destroyed() {
  clearInterval(this.timer);
  clearInterval(this.timer1);
  clearInterval(this.timer2);
}), _defineProperty(_components$data$dest, "methods", {
  // 获取所有数据
  initData: function initData(id) {
    this.getSiteList();
    this.getStandard(id);
    this.getSiteDetail(id);
    this.getAir(id);
    this.getReport(id);
    this.getPolutionData(id);
    this.getSkyList(id);
    this.getWarn();
  },
  getSiteList: function getSiteList() {
    var _this2 = this;

    querySiteList({
      current: 1,
      size: 100000
    }).then(function (res) {
      if (res.success && res.result.records.length > 0) {
        _this2.siteList = res.result.records;
        _this2.defaultSite = res.result.records[0].id;

        _this2.$forceUpdate();
      }
    });
  },
  // 获取空气质量实时数据
  getAir: function getAir(id) {
    var _this3 = this;

    getAction("/online/nchky/api/realtime/", {
      scope: 1,
      scopeId: id,
      st: 22,
      type: 1
    }).then(function (res) {
      if (res.success) {
        _this3.realTimeData = [];
        res.result.query.factors.forEach(function (item, index) {
          if (item.code == "a99901") return;
          var obj = {
            title: item.title,
            value: 0
          };

          if (res.result.records.length > 0) {
            obj.value = res.result.records[0].factor.hasOwnProperty(item.code) ? res.result.records[0].factor[item.code].value : 0;
          }

          _this3.realTimeData.push(obj);
        });

        if (res.result && res.result.records.length > 0) {
          if (res.result.records[0].attrs.aqi) {
            _this3.$refs.instrument.initBarChart(res.result.records[0].attrs.aqi.aqi, res.result.records[0].attrs.aqi.degree, res.result.records[0].attrs.aqi.color);

            _this3.firstPollution = res.result.records[0].attrs.aqi.name;
          } else {
            _this3.$refs.instrument.initBarChart(0, '无', '#fff');

            _this3.firstPollution = '--';
          }

          var obj = {};
          var arr = [];
          var title = [];
          res.result.query.factors.forEach(function (item, index) {
            // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
            if (res.result.records[0].factor[item.code] && res.result.records[0].factor[item.code].value != null) {
              arr.push(res.result.records[0].factor[item.code].value);
              title.push(item.title);
            }
          });

          if (arr.length > 6) {
            // this.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100)
            clearInterval(_this3.timer1);
            _this3.timer1 = setInterval(function () {
              arr.push(arr[0]); // 将数组的第一个元素添加到数组的

              arr.shift();
              title.push(title[0]); // 将数组的第一个元素添加到数组的

              title.shift(); // this.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6),
              // 100)
            }, 2000);
          } else {// this.$refs.bartype.initBarChart(arr, title, 100)
          }
        } else {
          if (res.result.query.factors.length > 0) {
            var _obj = {};
            var _arr = [];
            var _title = [];
            res.result.query.factors.forEach(function (item, index) {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              _arr.push(0);

              _title.push(item.title);
            });

            if (res.result.query.factors.length > 6) {
              // this.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100)
              clearInterval(_this3.timer2);
              _this3.timer2 = setInterval(function () {
                _arr.push(_arr[0]); // 将数组的第一个元素添加到数组的


                _arr.shift();

                _title.push(_title[0]); // 将数组的第一个元素添加到数组的


                _title.shift(); // this.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6),
                // 100)

              }, 2000);
            } else {// this.$refs.bartype.initBarChart(arr, title, 100)
            }
          } else {// this.$refs.bartype.initBarChart([], [], 100)
          }

          _this3.$refs.instrument.initBarChart(0, '无', '#fff');

          _this3.firstPollution = '--';
        } // this.$refs.schedule.initBarChart()

      }
    });
  },
  // 点击蓝天日历产看饼图的饼图图标
  ontoSelect: function ontoSelect() {
    this.showDetail = true;
    this.showIt = true;
  },
  // 普通日历日期选择器
  monthChange: function monthChange(value) {
    this.quantum = value;

    if (this.siteId) {
      this.getReport(this.siteId);
    }
  },
  // 获取日期
  getDay: function getDay(day) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码

    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    var hour = today.getHours();
    var minute = today.getMinutes();
    var second = today.getSeconds();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
  },
  doHandleMonth: function doHandleMonth(month) {
    var m = month;

    if (month.toString().length == 1) {
      m = '0' + month;
    }

    return m;
  },
  getDaysInOneMonth: function getDaysInOneMonth(year, month) {
    month = parseInt(month, 10);
    var d = new Date(year, month, 0);
    return d.getDate();
  },
  // 获取蓝天日历数据
  getReport: function getReport(id) {
    var _this4 = this;

    querSkyReport({
      scopeId: id,
      scope: 1,
      st: 22,
      type: 3,
      quantum: this.quantum
    }).then(function (res) {
      if (res.success) {
        var a = [];
        var aqiArr = [];

        var num = _this4.getDaysInOneMonth(_this4.quantum.split('-')[0], _this4.quantum.split('-')[1]);

        res.result.records.forEach(function (item, index) {
          if (index < num) {
            if (item.attrs.aqi) {
              for (var i = 0; i < _this4.standardList.length; i++) {
                if (_this4.standardList[i].data.alias == item.attrs.aqi.degree) {
                  a.push(i);
                  break;
                }
              }
            } else {
              a.push(_this4.standardList.length);
            }
          }
        });
        res.result.records.forEach(function (item, index) {
          if (item.attrs.aqi) {
            aqiArr.push(item.attrs.aqi.aqi);
          } else {
            aqiArr.push('暂无数据');
          }
        });

        _this4.$nextTick(function () {
          _this4.$refs.calendar.initBarChart(_this4.quantum.split('-')[0], _this4.quantum.split('-')[1], a, _this4.colors, _this4.title, aqiArr);
        });
      }
    });
  },
  // 获取国标数据
  getStandard: function getStandard(id) {
    var _this5 = this;

    queryStandardTreeList().then(function (res) {
      if (res.success) {
        // res.result[0].children[0].children.forEach((item, index) => {
        //   item.data.title = item.data.title.replace('类', '')
        //   item.data.show = true
        //   return item
        // })
        var arr = [];
        var stand = [];
        _this5.colors = ['#ccc'];
        res.result.forEach(function (item, index) {
          if (item.label == '国家标准') {
            if (item.children != null) {
              item.children.forEach(function (item1, index1) {
                if (item1.key == 'K1_2') {
                  arr = item1.children;
                  stand = JSON.parse(JSON.stringify(item1.children));
                  return;
                }
              });
            }
          }
        });
        var colors = [];
        var title = [];
        arr.forEach(function (item, index) {
          // item.data.title = item.data.title.replace('类', '')
          colors.push(item.data.color);
          title.push(item.data.title); // return item
        });
        _this5.title = title; // // stand.forEach((item, index) => {
        // // 	item.data.title = item.data.title.replace('类', '')
        // // 	return item
        // // })

        _this5.colors = [].concat(colors, _toConsumableArray(_this5.colors));
        _this5.standardList = arr;
        _this5.stand = stand;

        _this5.getReport(id);
      }
    });
  },
  // 饼图日历日期选择器
  changemMonth: function changemMonth(value) {
    var _this6 = this;

    this.showPie = false;
    this.$nextTick(function () {
      _this6.showPie = true;

      if (_this6.siteId) {
        _this6.getStandmonth(_this6.siteId, value);
      }
    });
  },
  // 获取单个月标准次数饼图
  getStandmonth: function getStandmonth(id, quantum) {
    var _this7 = this;

    jxSkyStandardMonth({
      scopeId: id,
      quantum: quantum
    }).then(function (res) {
      if (res.success) {
        var label = [];
        var a = [];
        var color = [];
        var arr = [];
        var data = [];
        res.result.standard.forEach(function (item, index) {
          label.push(item.alias);
        });
        var monthArr = Object.keys(res.result.monthStandard);
        monthArr.forEach(function (item, index) {
          if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
            var arrs = [];
            var obj = {};

            for (var i = 0; i < res.result.standard.length; i++) {
              obj.name = res.result.standard[i].alias;
              obj.color = res.result.standard[i].color;

              if (res.result.monthStandard[item][res.result.standard[i].alias]) {
                obj.value = res.result.monthStandard[item][res.result.standard[i].alias].num;
                color.push(res.result.standard[i].color);
              } else {
                obj.value = 0;
                color.push('');
              }

              data.push(obj);
              obj = {};
            }

            arr.push(data);
            data = [];
            color = [];
          } else {
            var _obj2 = {};

            for (var _i = 0; _i < res.result.standard.length; _i++) {
              color.push('');
              _obj2.name = res.result.standard[_i].alias;
              _obj2.color = res.result.standard[_i].color;
              _obj2.value = 0;
              data.push(_obj2);
              _obj2 = {};
            }

            arr.push(data);
            data = [];
          }
        });

        _this7.$refs.pie.initBarChart(quantum, label, arr);
      }
    });
  },
  // 站点警报的tab切换
  changetadios: function changetadios(e) {
    this.defaultValues = e;
    if (e == 0) this.radioIndex = '';else this.radioIndex = e;
    this.getWarn(this.radioIndex, this.siteId, '22'); // this.getWarn(this.radioIndex,this.selectType)
  },
  //获取预警内容
  getWarn: function getWarn(category, siteId, st) {
    var _this8 = this;

    var params = {
      category: category,
      scopeId: 6,
      scope: 4,
      warnStatus: 1
    }; // 污水站点

    queryScreenWarn(params).then(function (res) {
      if (res.success && res.result.length > 0) {
        res.result.forEach(function (item, index) {
          switch (item.category) {
            case '1':
              item.category_dictText = '数据报警';
              break;

            case '2':
              item.category_dictText = '设备报警';
              break;

            case '4':
              item.category_dictText = '离线预警';
              break;
          }
        });
        _this8.waterWarnList = res.result;
      } else {
        _this8.waterWarnList = [];
      }
    });
  },
  changeSiteRadio: function changeSiteRadio(e) {
    this.defaultSite = e.target.value;
  },
  // 点击aqi  tab的切换
  changeRadio: function changeRadio(e) {
    var time;

    switch (e.target.value) {
      case 1:
        this.analysisType = 11;
        this.getPolutionData(209, this.getDay(0));
        break;

      case 2:
        this.analysisType = 12;
        this.getPolutionData(209, this.getDay(7));
        break;

      case 3:
        this.analysisType = 12;
        this.getPolutionData(209, this.getDay(30));
        break;
    }
  },
  // 获取AQI数据
  getPolutionData: function getPolutionData(id, start) {
    var _this9 = this;

    if (id) this.siteId = id;
    if (!start) start = this.getDay(0);
    querySkyCurveAnalysis({
      scopeId: this.siteId,
      type: 1,
      stime: start,
      etime: this.getDay(0),
      dataType: this.analysisType
    }).then(function (res) {
      if (res.success) {
        if (res.result.records.length > 0) {
          var obj = {};
          var popArr = [];
          var arr = [];
          var time = [];
          var labelData = [];
          var seriesData = {};
          res.result.query.factors.forEach(function (ele) {
            if (ele.alias == 'AQI') return;
            labelData.push(ele.title);
            res.result.records.forEach(function (element) {
              if (element.factor[ele.code]) {
                obj.name = element.dataTime;
                obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value.toFixed(2) : '';
                arr.push(obj);
                obj = {};
              }
            });
            seriesData.data = arr;
            seriesData.title = ele.title;
            popArr.push(seriesData);
            seriesData = {};
            arr = [];
          });
          res.result.records.forEach(function (data) {
            time.push(data.dataTime);
          });
          _this9.showAnalysis = false;

          _this9.$nextTick(function () {
            _this9.showAnalysis = true;

            _this9.$nextTick(function () {
              _this9.$refs.pollution.initBarChart(popArr, time, labelData);
            });
          });
        } else {
          var _labelData = [];
          res.result.query.factors.forEach(function (item, index) {
            _labelData.push(item.title);
          });
          _this9.showAnalysis = false;

          _this9.$nextTick(function () {
            _this9.showAnalysis = true;

            _this9.$nextTick(function () {
              _this9.$refs.pollution.initBarChart([], [], _labelData);
            });
          });
        }
      }
    });
  },
  // 获取空气质量指数仪表盘数据
  getSkyList: function getSkyList(id) {
    var _this10 = this;

    getAction('/online/nchky/api/pie', {
      scope: 1,
      scopeId: id
    }).then(function (res) {
      if (res.success && res.result) {
        // this.$refs.plate.initBarChart(res.result['excellent'])
        // this.$refs.doublePlate.initBarChart(res.result['PM25'], res.result['pollution'])
        var values = [res.result['PM25'].someNum, res.result['PM25'].nowNum, res.result['excellent'].someNum, res.result['excellent'].nowNum, res.result['pollution'].someNum, res.result['pollution'].nowNum];
        var datas = ['上月PM2.5达标天数', '本月PM2.5达标天数', '上月优良天数', '本月优良天数', '上月重污染天数', '本月重污染天数'];

        _this10.$refs.dayBarType.initBarChart(values, datas, 31);
      } else {
        // this.$refs.plate.initBarChart({
        // 	someNum: 0,
        // 	nowNum: 0
        // })
        // this.$refs.doublePlate.initBarChart({
        // 	someNum: 0,
        // 	nowNum: 0
        // }, {
        // 	someNum: 0,
        // 	nowNum: 0
        // })
        var _values = [0, 0, 0, 0, 0, 0];
        var _datas = ['上月PM2.5达标天数', '本月PM2.5达标天数', '上月优良天数', '本月优良天数', '上月重污染天数', '本月重污染天数'];

        _this10.$refs.dayBarType.initBarChart(_values, _datas, 31);
      }
    });
  },
  // 获取对应点击的站点的站点详情
  getSiteDetail: function getSiteDetail(id) {
    var _this11 = this;

    queryBigDataById({
      id: id
    }).then(function (res) {
      if (res.success) {
        res.result.photo = _this11.getImageView(res.result.photo);
        _this11.siteDetail = res.result;
      }
    });
  },
  getImageView: function getImageView(photo) {
    return this.imgerver + '/' + photo;
  },
  resetWidth: function resetWidth() {
    this.$refs.border.width = document.documentElement.clientWidth * 0.75;
    this.$refs.border.height = document.documentElement.clientHeight * 0.22;
    this.$refs.border1.width = document.documentElement.clientWidth * 0.32;
    this.$refs.border1.height = document.documentElement.clientHeight * 0.32;
    this.$refs.border2.width = document.documentElement.clientWidth * 0.32;
    this.$refs.border2.height = document.documentElement.clientHeight * 0.32;
    this.calendarHeight = document.documentElement.clientHeight * 0.26 + 'px';
    this.$refs.border3.width = document.documentElement.clientWidth * 0.32;
    this.$refs.border3.height = document.documentElement.clientHeight * 0.32;
    this.warnHeight = document.documentElement.clientHeight * 0.3 + 'px';
    this.$refs.border4.width = document.documentElement.clientWidth * 0.4;
    this.$refs.border4.height = document.documentElement.clientHeight * 0.32;
    this.analysisHeight = document.documentElement.clientHeight * 0.29 + 'px';
    this.$refs.border5.width = document.documentElement.clientWidth * 0.57;
    this.$refs.border5.height = document.documentElement.clientHeight * 0.32;
  }
}), _components$data$dest);